<div class="tt-color-preset-card_name">
  {{ colorPreset()?.name }}
</div>

<div class="tt-color-preset-card_preview">
  <div class="tt-color-preset-card_preview-fill tt-color-preset-card_preview-stroke"></div>
  <div class="tt-color-preset-card_preview-text">T</div>
</div>

@if (!readonly()) {
  <div class="tt-color-preset-card_actions">
    <button ttButton [emphasis]="'minimal'" [size]="'small'" [variant]="'primary'" (click)="editClicked.emit()">
      <mat-icon [icon]="'pencil'" />
    </button>
    <button ttButton [emphasis]="'minimal'" [size]="'small'" [variant]="'primary'" (click)="deleteClicked.emit()">
      <mat-icon [icon]="'trash'" />
    </button>
  </div>
}
